<template>
  <Page :title="$t('app_name')">
    <UserLoginForm />
  </Page>
</template>

<script>
import Page from "@/components/Elements/Page";
import ViewMixin from "@/mixins/View";
import UserLoginForm from "@/components/UserAccount/UserLoginForm";

export default {
  name: "LoginView",
  components: {
    UserLoginForm,
    Page
  },
  mixins: [ViewMixin]
};
</script>

<style></style>
